import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	createField: {
		id: 'polaris-ideas.right-sidebar.field-create.create-field',
		defaultMessage: 'Create a field',
		description: 'Label on right sidebar header when creating a field',
	},
});
